import React, { useEffect } from "react";
import withIntl from "../../../utils/withIntl";
import cloudStore from "../../../store/CloudStore";
import { getPaynlMerchants, getPaynlPinterminals, updatePaynlMerchant } from "./PaynlApi";
import EditTextField from "../../EditArticle/EditTextField";
import EditCheckbox from "../../EditArticle/EditCheckbox";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, Divider, Grid, Paper, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../../AuthorizationWrapper";

function Paynl(props) {
  const [paynlMerchant, setPaynlMerchant] = React.useState(props.paynlMerchant);
  const [availablePaynlMerchants, setAvailablePaynlMerchants] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);

  let loading = open && options.length === 0;

  useEffect(() => {
    getPaynlMerchants(paynlMerchant?.api_token).then((paynlMerchants) => {
      setAvailablePaynlMerchants(paynlMerchants);
    });
  }, []);

  const searchAvailablePaynlMerchants = (searchValue) => {
    if (!availablePaynlMerchants) {
      return [];
    }
    if (paynlMerchant && searchValue.length === 0) {
      let merchant = availablePaynlMerchants.find(
        (merchant) =>
          merchant.merchantId === paynlMerchant.ext_paynl_merchant_id &&
          merchant.serviceId === paynlMerchant.ext_paynl_service_id
      );
      if (merchant && selectedOption == null) {
        setSelectedOption(merchant);
      }
    }
    return availablePaynlMerchants.reduce((merchants, merchant) => {
      if (merchants.length > 9) {
        return merchants;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (
            merchant.merchantName.toLowerCase().includes(value.toLowerCase()) ||
            merchant.serviceName.toLowerCase().includes(value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      ) {
        merchants.push(merchant);
      }

      return merchants;
    }, []);
  };

  useEffect(() => {
    if (
      selectedOption &&
      paynlMerchant?.ext_paynl_merchant_id !== selectedOption.merchantId &&
      paynlMerchant?.ext_paynl_service_id !== selectedOption.serviceId
    ) {
      updatePaynlMerchant(paynlMerchant, {
        merchant_id: cloudStore.merchant.id,
        ext_paynl_merchant_id: selectedOption.merchantId,
        ext_paynl_service_id: selectedOption.serviceId,
      }).then((paynlMerchant) => {
        setPaynlMerchant(paynlMerchant);
      });
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const merchants = await searchAvailablePaynlMerchants(searchValue);
      if (active) {
        setOptions(merchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue, availablePaynlMerchants]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  if (!availablePaynlMerchants) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Paper style={{ width: "520px", padding: "16px", margin: "16px" }}>
      <Typography variant={"h6"}>Paynl Service (Verkooplocatie)</Typography>

      {!selectedOption && <Typography>No Paynl service connected</Typography>}
      {selectedOption && paynlMerchant && (
        <Grid container spacing={1} style={{ margin: 16 }} alignItems={"center"}>
          <Grid item xs={6}>
            Paynl Merchant Id
          </Grid>
          <Grid item xs={6}>
            {selectedOption.merchantId}
          </Grid>
          <Grid item xs={6}>
            Paynl Service Id
          </Grid>
          <Grid item xs={6}>
            {selectedOption.serviceId}
          </Grid>
          <Grid item xs={6}>
            Paynl Merchant Name
          </Grid>
          <Grid item xs={6}>
            {selectedOption.merchantName}
          </Grid>
          <Grid item xs={6}>
            Paynl Service Name
          </Grid>
          <Grid item xs={6}>
            {selectedOption.serviceName}
          </Grid>
          <Grid item xs={6}>
            Demo mode
          </Grid>
          <Grid item xs={6}>
            <EditCheckbox
              value={paynlMerchant.demo}
              onChange={(value) => {
                updatePaynlMerchant(paynlMerchant, { demo: value }).then((paynlMerchant) => {
                  setPaynlMerchant(paynlMerchant);
                });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            Api token
          </Grid>
          <Grid item xs={6}>
            <EditTextField
              label={"api token"}
              value={paynlMerchant.api_token ? paynlMerchant.api_token : ""}
              onBlur={(value, setBeginValue) => {
                if (value === "") {
                  value = null;
                }
                updatePaynlMerchant(paynlMerchant, { api_token: value }).then((paynlMerchant) => {
                  setPaynlMerchant(paynlMerchant);
                  setBeginValue(value);
                });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            secret (IDEAL QR)
          </Grid>
          <Grid item xs={6}>
            <EditTextField
              label={"secret (IDEAL QR)"}
              value={paynlMerchant.secret ? paynlMerchant.secret : ""}
              onBlur={(value, setBeginValue) => {
                updatePaynlMerchant(paynlMerchant, { secret: value }).then((paynlMerchant) => {
                  setPaynlMerchant(paynlMerchant);
                  setBeginValue(value);
                });
              }}
            />
          </Grid>
        </Grid>
      )}

      <AuthorizationWrapper
        permission={"paynl.connect_merchant"}
        child={
          <>
            <Divider />
            <Typography variant={"h6"}>Connect to other paynl service</Typography>
            <Autocomplete
              style={{ width: 300 }}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
                setSearchValue("");
              }}
              filterOptions={(x) => x}
              onChange={(e, value) => {
                if (value) {
                  setSelectedOption(value);
                }
              }}
              onInputChange={(event, value) => {
                setSearchValue(value);
              }}
              getOptionSelected={(option, value) => {
                return option.merchantId === value.merchantId && option.serviceId === value.serviceId;
              }}
              getOptionLabel={(option) => option.merchantName + " - " + option.serviceName}
              options={options}
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={props.intl.formatMessage({ id: "Search" })}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </>
        }
      />
    </Paper>
  );
}

export default withIntl(Paynl);
